import { render, staticRenderFns } from "./QuestionPlanDownload.vue?vue&type=template&id=26d44b32&scoped=true&"
import script from "./QuestionPlanDownload.vue?vue&type=script&lang=js&"
export * from "./QuestionPlanDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d44b32",
  null
  
)

export default component.exports